export enum ProfileType {
    Viewer = 0,
    Vendor = 1,
    Manager = 2,
    Ecommerce = 3,
    Admin = 4,
    GlobalPicker = 5,
    Assembler = 6
}